import { ReactComponent as FlagIcon } from "./svg/hu-flag.svg";
import "../flag-icon.scss";

export const HUFlag = () => {
  return (
    <span className="flag-icon">
      <FlagIcon />
    </span>
  );
};
